import React from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_BLANK } from "../Common/constant";
import success from "@Images/successs.png";

const Success = (props) => {
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_BLANK}
            backprops={"/DummyDashboard"}
            history={props.history}
          />
          <div className="wrapper-content">
            <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="success_scc">
                  <img src={success} alt="success" />
                  <br />
                  <br />
                  <p>We have emailed you the signed copy of Loan agreement</p>
                  <br />
                  <p>
                    <strong>
                      If not redirect please go back or close the tab
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
